import React from 'react'

export const Error404 = () => {
    return (
        <div className="system">
            <h2 className="system__title">Opps!</h2>
        </div>
    )
}